/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
Device Detection - Check if is mobile or ipad
========================================================================== */

let isMobile = false; // initiate as false
const isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
  isMobile = true;
}

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line--added)");
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fas, .far, .fal, .fab");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='linkline'>" + el.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line--added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();
linksInit();

/*  ==========================================================================
GENERAL - LazyLoad - Enable Lazy load for images
========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
  Contact Form Footer
  ========================================================================== */
const contactButtons = document.querySelectorAll(".sitefooter__contact");
const contactForm = document.querySelector(".contact-form");
const overlay = document.querySelector(".overlay");
const closeButton = document.querySelector(".contact-form__close");

const contactFormInit = function () {
  if (!contactButtons) {
    return;
  }

  contactButtons.forEach(function (contactButton) {
    contactButton.addEventListener("click", function (e) {
      e.preventDefault();
      contactForm.classList.toggle("active");
      overlay.classList.toggle("active");
      // Create a new URL object for the current location
      const url = new URL(window.location.href);

      // Add or update the `popup` query parameter
      url.searchParams.set("popup", "true");

      // Update the URL in the browser without reloading the page
      window.history.pushState({}, "", url);
    });
  });

  overlay.addEventListener("click", function (e) {
    e.preventDefault();
    contactForm.classList.remove("active");
    overlay.classList.remove("active");

    // Create a new URL object for the current location
    const url = new URL(window.location.href);

    // Remove the `popup` query parameter
    url.searchParams.delete("popup");

    // Update the URL in the browser without reloading the page
    window.history.pushState({}, "", url);
  });

  closeButton.addEventListener("click", function (e) {
    e.preventDefault();
    contactForm.classList.remove("active");
    overlay.classList.remove("active");

    // Create a new URL object for the current location
    const url = new URL(window.location.href);

    // Remove the `popup` query parameter
    url.searchParams.delete("popup");

    // Update the URL in the browser without reloading the page
    window.history.pushState({}, "", url);
  });

  // Check if the URL query string contains `popup=true`
  window.addEventListener("load", () => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("popup") === "true") {
      contactForm.classList.toggle("active");
      overlay.classList.toggle("active");
    }
  });
}; // contactFormInit();
contactFormInit();

// /*  ==========================================================================
//   Connect Form (Advisors)
//   ========================================================================== */
// const connectButtons = document.querySelectorAll(".person__contact--connect");
// const connectForm = document.querySelector(".contact-form__connect");
// const connectOverlay = document.querySelector(".overlay");
// const connectCloseButton = document.querySelector(".contact-form__connect__close");

// const connectFormInit = function () {
//   if (!connectCloseButton) {
//     return;
//   }

//   connectButtons.forEach(function (connectButton) {
//     connectButton.addEventListener("click", function (e) {
//       e.preventDefault();
//       connectForm.classList.toggle("active");
//       overlay.classList.toggle("active");
//       // Create a new URL object for the current location
//       const url = new URL(window.location.href);

//       const fieldName = document.querySelector(".advisor-field");
//       const getName = this.getAttribute("data-name");
//       fieldName.value = getName;

//       // Trigger 'input' and 'change' events to notify Ninja Forms
//       var inputEvent = new Event("input", { bubbles: true });
//       var changeEvent = new Event("change", { bubbles: true });

//       fieldName.dispatchEvent(inputEvent);
//       fieldName.dispatchEvent(changeEvent);

//       // Update the URL in the browser without reloading the page
//       window.history.pushState({}, "", url);
//     });
//   });

//   connectOverlay.addEventListener("click", function (e) {
//     e.preventDefault();
//     connectForm.classList.remove("active");
//     connectOverlay.classList.remove("active");

//     // Create a new URL object for the current location
//     const url = new URL(window.location.href);

//     // Remove the `popup` query parameter
//     url.searchParams.delete("popup");

//     // Update the URL in the browser without reloading the page
//     window.history.pushState({}, "", url);
//   });

//   connectCloseButton.addEventListener("click", function (e) {
//     e.preventDefault();
//     connectForm.classList.remove("active");
//     connectOverlay.classList.remove("active");

//     // Create a new URL object for the current location
//     const url = new URL(window.location.href);

//     // Remove the `popup` query parameter
//     url.searchParams.delete("popup");

//     // Update the URL in the browser without reloading the page
//     window.history.pushState({}, "", url);
//   });

//   // Check if the URL query string contains `popup=true`
// }; // contactFormInit();
// connectFormInit();

/*  ==========================================================================
  Homepage Marquee Animation
  ========================================================================== */
const marqueeTop = document.querySelector(".marquee--top");
const marqueeBottom = document.querySelector(".marquee--bottom");

const marqueeInit = function () {
  if (!marqueeTop) {
    return;
  }

  let scrollY = 0;
  let ticking = false;

  window.addEventListener("scroll", () => {
    scrollY = window.scrollY;

    if (!ticking) {
      window.requestAnimationFrame(updateMarquees);
      ticking = true;
    }
  });

  function updateMarquees() {
    marqueeTop.style.transform = `translate3d(-${scrollY}px, 0, 0)`;
    marqueeBottom.style.transform = `translate3d(${scrollY}px, 0, 0)`;
    ticking = false;
  }

  
}; // marqueeInit();
marqueeInit();

 

/*  ==========================================================================
  Home Page Alert Banner
  ========================================================================== */
const alertBanner = document.querySelector(".alert");
const alertBannerCloseButton = document.querySelector(".alert__body__close");
const alertBannerInit = function () {
  if (!alertBanner) {
    return;
  }
  // Helper function to set a cookie
  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
  }

  // Helper function to get a cookie
  function getCookie(name) {
    const nameEQ = name + "=";
    const cookies = document.cookie.split(";");
    for (let cookie of cookies) {
      cookie = cookie.trim();
      if (cookie.indexOf(nameEQ) === 0) {
        return cookie.substring(nameEQ.length, cookie.length);
      }
    }
    return null;
  }

  // Check if the cookie consent has already been given
  if (getCookie("cookiesAccepted")) {
    alertBanner.style.display = "none";
  }

  if (!getCookie("cookiesAccepted")) {
    alertBanner.style.display = "block";
  }

  // Add event listeners to buttons
  alertBannerCloseButton.addEventListener("click", () => {
    setCookie("cookiesAccepted", "true", 30); // Set cookie for 30 days
    alertBanner.style.display = "none";
  });
}; // alertBannerInit();
alertBannerInit();

/*  ==========================================================================
	GENERAL - sharinglinks
========================================================================== */

$(".sharelink--popup").click(function (e) {
  e.preventDefault();
  window.open($(this).attr("href"), "share-dialog", "width=550,height=436");
});

/*  ==========================================================================
Accordion
========================================================================== */
const accordionQuestions = document.querySelectorAll(".faq__question");

const accordionInit = function (accordionItems) {
  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(item =>
    item.addEventListener("click", function () {
      this.classList.toggle("active");
      this.parentElement.classList.toggle("faq--open");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }

      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    })
  );
}; // accordionInit();
accordionInit(accordionQuestions);

/*  ==========================================================================
AJAX - AJAX load more / paging
========================================================================== */

const loadmoreBtn = document.querySelector(".paging__loadmore");
const loadmoreContainer = document.querySelector(".loadmore-container");

const loadmoreLoadPostsMultiplePages = function (pages) {
  if (pages && pages > 1) {
    //Stopping default scroll back to previous position
    history.scrollRestoration = "manual";

    const currentPage = new URL(window.location);

    //Creating an array on page numbers to map it
    var list = [];
    for (var i = 1; i < pages; i++) {
      list.push(i);
    }

    // Initialising the array of posts pages
    var postsHTML = [];

    const button = loadmoreBtn;
    const buttonText = button.textContent; // store current button text
    button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts

    // Array of ajax calls
    var allAJAX = list.map(function (page) {
      const data = {
        action: "loadmore",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function
        page: page,
        security: php_variables.nonce
      };
      //Updating the url to mtch the page number
      currentPage.searchParams.set("pagenum", page);
      return $.ajax({
        url: php_variables.ajax_url, // AJAX handler
        data: data,
        type: "POST",
        success: function (data) {
          postsHTML[page] = data;
        }
      });
    });

    // Waiting for all the ajax calls to be finished before proceeding
    Promise.all(allAJAX).then(function () {
      // Update current page variable
      php_variables.current_page = pages;

      button.textContent = buttonText; // set back to previous button text

      // Adding the new tiles to the dom
      list.map(page => {
        if (postsHTML[page]) {
          loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + postsHTML[page];
        }
      });

      // Updating the href for the loadmore button
      const nextPage = new URL(window.location);
      nextPage.searchParams.set("pagenum", parseInt(pages) + 1);
      button.href = nextPage;

      // if last page, remove the button..
      if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
        button.style.display = "none";
      }

      // Re-init links to make sure linklines on newly loaded content still work
      linksInit();
      // Re-init lazy load
      lazyLoadInstance.update(); // reinit lazy load after clones

      // Re-init effects
      const effects = document.querySelectorAll(".effect");
      effectsInit(effects);

      const connectButtons = document.querySelectorAll(".person__contact--connect");
      const connectForm = document.querySelector(".contact-form__connect");
      const connectOverlay = document.querySelector(".overlay");
      const connectCloseButton = document.querySelector(".contact-form__connect__close");

      const connectFormInit = function () {
        if (!connectCloseButton) {
          return;
        }

        connectButtons.forEach(function (connectButton) {
          connectButton.addEventListener("click", function (e) {
            e.preventDefault();
            connectForm.classList.toggle("active");
            overlay.classList.toggle("active");
            // Create a new URL object for the current location
            const url = new URL(window.location.href);

            const fieldName = document.querySelector(".advisor-field");
            const getName = this.getAttribute("data-name");
            fieldName.value = getName;

            // Trigger 'input' and 'change' events to notify Ninja Forms
            var inputEvent = new Event("input", { bubbles: true });
            var changeEvent = new Event("change", { bubbles: true });

            fieldName.dispatchEvent(inputEvent);
            fieldName.dispatchEvent(changeEvent);

            // Update the URL in the browser without reloading the page
            window.history.pushState({}, "", url);
          });
        });

        connectOverlay.addEventListener("click", function (e) {
          e.preventDefault();
          connectForm.classList.remove("active");
          connectOverlay.classList.remove("active");

          // Create a new URL object for the current location
          const url = new URL(window.location.href);

          // Remove the `popup` query parameter
          url.searchParams.delete("popup");

          // Update the URL in the browser without reloading the page
          window.history.pushState({}, "", url);
        });

        connectCloseButton.addEventListener("click", function (e) {
          e.preventDefault();
          connectForm.classList.remove("active");
          connectOverlay.classList.remove("active");

          // Create a new URL object for the current location
          const url = new URL(window.location.href);

          // Remove the `popup` query parameter
          url.searchParams.delete("popup");

          // Update the URL in the browser without reloading the page
          window.history.pushState({}, "", url);
        });

        // Check if the URL query string contains `popup=true`
      }; // contactFormInit();
      connectFormInit();

      const companyToggles = document.querySelectorAll(".company__top");
      const companyTiles = document.querySelectorAll(".tile--company");

      const companyAccordionInit = function () {
        if (!companyToggles) {
          return;
        }

        companyToggles.forEach(companyToggle => {
          companyToggle.addEventListener("click", function (evt) {
            if (!companyToggle.parentElement.parentElement.parentElement.classList.contains("active")) {
              companyTiles.forEach(companyTile => {
                companyTile.classList.remove("active");
                companyTile.classList.remove("active__bottom");
              });

              companyToggle.parentElement.parentElement.parentElement.classList.toggle("active");
              setTimeout(() => {
                companyToggle.parentElement.parentElement.parentElement.classList.toggle("active__bottom");
              }, 250);
            } else {
              companyToggle.parentElement.parentElement.parentElement.classList.remove("active");
              setTimeout(() => {
                companyToggle.parentElement.parentElement.parentElement.classList.remove("active__bottom");
              }, 250);
            }
          });
        });
      };
      companyAccordionInit();

      // Scrolling the page to the last known position
      if (localStorage.getItem("scrollPosition")) {
        window.scroll({
          top: parseInt(localStorage.getItem("scrollPosition"), 10),
          behavior: "instant"
        });
      }
    });
  }
};

const loadmoreLoadPosts = function () {
  const button = this;
  const data = {
    action: "loadmore",
    query: php_variables.posts, // that's how we get params from wp_localize_script() function
    page: php_variables.current_page,
    security: php_variables.nonce
  };
  let buttonText; // create variable to store button text

  // This AJAX triggers a PHP hook within function-hooks.php called ajax_loadmore_handler
  $.ajax({
    url: php_variables.ajax_url, // AJAX handler
    data: data,
    type: "POST",
    beforeSend: function (xhr) {
      buttonText = button.textContent; // store current button text
      button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
    },
    success: function (data) {
      if (data) {
        button.textContent = buttonText; // set back to previous button text
        loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts
        php_variables.current_page++;

        // Only push state to set the last page number or if there is more pages to load
        const currentPage = new URL(window.location);

        if (parseInt(php_variables.current_page) <= parseInt(php_variables.max_page)) {
          currentPage.searchParams.set("pagenum", php_variables.current_page);
          history.pushState({}, "", currentPage);
        }

        // if last page, remove the button..
        if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
          button.style.display = "none";
        }
        // Re-init links to make sure linklines on newly loaded content still work
        linksInit();
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        effectsInit();

        const connectButtons = document.querySelectorAll(".person__contact--connect");
        const connectForm = document.querySelector(".contact-form__connect");
        const connectOverlay = document.querySelector(".overlay");
        const connectCloseButton = document.querySelector(".contact-form__connect__close");

        const connectFormInit = function () {
          if (!connectCloseButton) {
            return;
          }

          connectButtons.forEach(function (connectButton) {
            connectButton.addEventListener("click", function (e) {
              e.preventDefault();
              connectForm.classList.toggle("active");
              overlay.classList.toggle("active");
              // Create a new URL object for the current location
              const url = new URL(window.location.href);

              const fieldName = document.querySelector(".advisor-field");
              const getName = this.getAttribute("data-name");
              fieldName.value = getName;

              // Trigger 'input' and 'change' events to notify Ninja Forms
              var inputEvent = new Event("input", { bubbles: true });
              var changeEvent = new Event("change", { bubbles: true });

              fieldName.dispatchEvent(inputEvent);
              fieldName.dispatchEvent(changeEvent);

              // Update the URL in the browser without reloading the page
              window.history.pushState({}, "", url);
            });
          });

          connectOverlay.addEventListener("click", function (e) {
            e.preventDefault();
            connectForm.classList.remove("active");
            connectOverlay.classList.remove("active");

            // Create a new URL object for the current location
            const url = new URL(window.location.href);

            // Remove the `popup` query parameter
            url.searchParams.delete("popup");

            // Update the URL in the browser without reloading the page
            window.history.pushState({}, "", url);
          });

          connectCloseButton.addEventListener("click", function (e) {
            e.preventDefault();
            connectForm.classList.remove("active");
            connectOverlay.classList.remove("active");

            // Create a new URL object for the current location
            const url = new URL(window.location.href);

            // Remove the `popup` query parameter
            url.searchParams.delete("popup");

            // Update the URL in the browser without reloading the page
            window.history.pushState({}, "", url);
          });

          // Check if the URL query string contains `popup=true`
        }; // contactFormInit();
        connectFormInit();

        const companyToggles = document.querySelectorAll(".company__top");
        const companyTiles = document.querySelectorAll(".tile--company");

        const companyAccordionInit = function () {
          if (!companyToggles) {
            return;
          }

          companyToggles.forEach(companyToggle => {
            companyToggle.addEventListener("click", function (evt) {
              if (!companyToggle.parentElement.parentElement.parentElement.classList.contains("active")) {
                companyTiles.forEach(companyTile => {
                  companyTile.classList.remove("active");
                  companyTile.classList.remove("active__bottom");
                });

                companyToggle.parentElement.parentElement.parentElement.classList.toggle("active");
                setTimeout(() => {
                  companyToggle.parentElement.parentElement.parentElement.classList.toggle("active__bottom");
                }, 250);
              } else {
                companyToggle.parentElement.parentElement.parentElement.classList.remove("active");
                setTimeout(() => {
                  companyToggle.parentElement.parentElement.parentElement.classList.remove("active__bottom");
                }, 250);
              }
            });
          });
        };
        companyAccordionInit();
      } else {
        button.remove(); // if no data, remove the button as well
      }
    }
  });
}; // loadmoreLoadPosts();

const loadmoreInit = function () {
  if (!loadmoreBtn) {
    return;
  }

  /** When adding fitering you will need to move this part into the filtering call */
  // Checking if the page paramenter is set
  const currentPage = new URL(window.location);
  let currentPageNum = currentPage.searchParams.get("pagenum");

  //If there is more than one page to load
  if (currentPageNum && currentPageNum > 1) {
    currentPageNum = currentPageNum > php_variables.max_page ? php_variables.max_page : currentPageNum;
    loadmoreLoadPostsMultiplePages(currentPageNum);
  }

  loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
}; // loadmoreInit();
loadmoreInit();

/*  ==========================================================================
    Scroll effects
    ========================================================================== */
const effects = document.querySelectorAll(".effect");

const effectsInit = function (effects, context) {
  if (!effects) {
    return;
  }

  effects.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          val.classList.add("effect--ready");
        } else {
          val.classList.remove("effect--ready");
        }
      },
      context: context,
      offset: "95%"
    });
  });
}; // effectsInit();

effectsInit(effects);

/*  ==========================================================================
      flexslides
      ========================================================================== */

var $flexslides = $(".flexslides .flexslides__carousel");

if ($flexslides.length > 0) {
  flexslides__init();
}

function flexslides__init() {
  $flexslides.each(function () {
    var $this = $(this);
    var $this_slidecount = $(".flexslide", $this).length;
    if ($this_slidecount > 1) {
      $this
        .owlCarousel({
          loop: true,
          nav: false,
          dots: true,
          items: 1,
          startPosition: $this_slidecount,
          //autoplay: true,
          //autoplayTimeout: 5000,
          autoHeight: true
        })
        .waypoint({
          handler: function (direction) {
            if (direction === "down" && $this.data("alreadyscrolled") !== "true") {
              $this.trigger("next.owl.carousel").data("alreadyscrolled", "true");
            }
          },
          offset: "50%"
        });
    }
  });

  $flexslides.on("resized.owl.carousel", function () {
    $flexslides.trigger("next.owl.carousel");
  });
} // flexslides__init()

/*  ==========================================================================
					People Category
					========================================================================== */

var $peoplecategories = $(".peoplecategory .peoplecategory__carousel");

if ($peoplecategories.length > 0) {
  peoplecategories__init();
}

function peoplecategories__init() {
  $peoplecategories.each(function () {
    var $this = $(this);
    var $this_slidecount = $(".peoplecategory__item", $this).length;
    if ($this_slidecount > 1) {
      $this.owlCarousel({
        loop: false,
        nav: true,
        navText: [
          '<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none"><g opacity="1"><path d="M24.0554 40.2882C21.1574 36.8442 18.0494 34.3242 14.8574 32.6862V31.5102C18.0494 29.8722 21.1574 27.3522 24.0554 23.9082H26.4914C25.1474 26.8482 23.8034 29.1162 22.4594 30.5862H33.4214V33.5682H22.4594C23.7614 35.0382 25.1474 37.3062 26.4914 40.2882H24.0554ZM36.4034 33.5682V30.5862H48.8774V33.5682H36.4034Z" fill="currentColor"/></g></svg>',
          '<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none"><path d="M39.6794 40.2882H37.2434C38.5874 37.3062 39.9734 35.0382 41.2754 33.5682H30.3134V30.5862H41.2754C39.9314 29.1162 38.5874 26.8482 37.2434 23.9082H39.6794C42.5774 27.3522 45.6854 29.8722 48.8774 31.5102V32.6862C45.6854 34.3242 42.5774 36.8442 39.6794 40.2882ZM27.3314 33.5682H14.8574V30.5862H27.3314V33.5682Z" fill="currentColor"/></svg>'
        ],
        dots: false,
        items: 3,
        startPosition: $this_slidecount,
        responsive: {
          0: {
            items: 1
          },
          550: {
            items: 2
          },
          700: {
            items: 3
          },
          1000: {
            items: 4
          }
        },
        autoHeight: true
      });
    }
  });
} // flexslides__init()

/*  ==========================================================================
      Featured Stories Carousel
      ========================================================================== */

var $featuredStoriesFeatured = $(".featuredstories .featuredstories__carousel--featured");

if ($featuredStoriesFeatured.length > 0) {
  featuredStoriesFeaturedCarousel__init();
}

function featuredStoriesFeaturedCarousel__init() {
  $featuredStoriesFeatured.each(function () {
    var $this = $(this);
    var owlCarousel = $this.owlCarousel({
      loop: true,
      nav: true,
      navText: [
        '<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none"><g opacity="1"><path d="M24.0554 40.2882C21.1574 36.8442 18.0494 34.3242 14.8574 32.6862V31.5102C18.0494 29.8722 21.1574 27.3522 24.0554 23.9082H26.4914C25.1474 26.8482 23.8034 29.1162 22.4594 30.5862H33.4214V33.5682H22.4594C23.7614 35.0382 25.1474 37.3062 26.4914 40.2882H24.0554ZM36.4034 33.5682V30.5862H48.8774V33.5682H36.4034Z" fill="currentColor"/></g></svg>',
        '<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none"><path d="M39.6794 40.2882H37.2434C38.5874 37.3062 39.9734 35.0382 41.2754 33.5682H30.3134V30.5862H41.2754C39.9314 29.1162 38.5874 26.8482 37.2434 23.9082H39.6794C42.5774 27.3522 45.6854 29.8722 48.8774 31.5102V32.6862C45.6854 34.3242 42.5774 36.8442 39.6794 40.2882ZM27.3314 33.5682H14.8574V30.5862H27.3314V33.5682Z" fill="currentColor"/></svg>'
      ],
      dots: false,
      items: 1,
      autoHeight: false,
      autoplay: true,
      autoplayTimeout: 10000,
      onInitialized: function () {
        setTimeout(function () {
          owlCarousel.trigger("refresh.owl.carousel");
        }, 500);
      }
    });
  });
} // featuredStoriesCarousel__init()

/*  ==========================================================================
					Featured Stories Carousel
					========================================================================== */

var $featuredStoriesTiles = $(".featuredstories .featuredstories__carousel--tiles");

if ($featuredStoriesTiles.length > 0) {
  featuredStoriesTilesCarousel__init();
}

function featuredStoriesTilesCarousel__init() {
  $featuredStoriesTiles.each(function () {
    var $this = $(this);
    $this.owlCarousel({
      loop: false,
      nav: true,
      navText: [
        '<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none"><g opacity="1"><path d="M24.0554 40.2882C21.1574 36.8442 18.0494 34.3242 14.8574 32.6862V31.5102C18.0494 29.8722 21.1574 27.3522 24.0554 23.9082H26.4914C25.1474 26.8482 23.8034 29.1162 22.4594 30.5862H33.4214V33.5682H22.4594C23.7614 35.0382 25.1474 37.3062 26.4914 40.2882H24.0554ZM36.4034 33.5682V30.5862H48.8774V33.5682H36.4034Z" fill="currentColor"/></g></svg>',
        '<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none"><path d="M39.6794 40.2882H37.2434C38.5874 37.3062 39.9734 35.0382 41.2754 33.5682H30.3134V30.5862H41.2754C39.9314 29.1162 38.5874 26.8482 37.2434 23.9082H39.6794C42.5774 27.3522 45.6854 29.8722 48.8774 31.5102V32.6862C45.6854 34.3242 42.5774 36.8442 39.6794 40.2882ZM27.3314 33.5682H14.8574V30.5862H27.3314V33.5682Z" fill="currentColor"/></svg>'
      ],
      dots: false,
      items: 1,
      autoHeight: true,
      responsive: {
        0: {
          items: 2
        },
        550: {
          items: 2
        },
        700: {
          items: 3
        },
        1000: {
          items: 4
        }
      }
    });
  });
} // featuredStoriesCarousel__init()

/*  ==========================================================================
      mobnav
      ========================================================================== */

var $mobnav = $(".mobnav");
var $mobnavinner = $(".mobnav__bd", $mobnav);
var $mobnavtoggle = $(".mobnav-toggle");
var mobnavopenclass = "mobnavopen";

mobnav__init();

function mobnav__init() {
  $mobnavtoggle.on("click touchend", function (e) {
    e.preventDefault();
    if ($mobnav.attr("data-status") !== "open") {
      // it's not open
      $mobnav.attr("data-status", "open");
      $("body").addClass(mobnavopenclass);
    } else {
      // it's open
      $mobnav.attr("data-status", "closed");
      $("body").removeClass(mobnavopenclass);
    }
  });

  $(window).resize(mobnav__resize);
} // mobnav__init()

function mobnav__resize() {
  if ($mobnav.attr("data-status") === "open") {
    $mobnav.height($mobnavinner.outerHeight(true)).attr("data-status", "open");
  }
} // mobnav__resize()

/*  ==========================================================================
NAVIGATION - Scroll animation
========================================================================== */
const scrollUp = "scroll-up";
const scrollDown = "scroll-down";
let lastScroll = 0;

window.addEventListener("scroll", () => {
  const currentScroll = window.scrollY;
  const scrollThreshold = 10;
  if (currentScroll <= scrollThreshold) {
    body.classList.remove(scrollUp, scrollDown);
    body.classList.add("top");
    return;
  }

  if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
    // down
    body.classList.remove(scrollUp);
    body.classList.add(scrollDown);
    body.classList.remove("top");
  } else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
    // up
    body.classList.remove(scrollDown);
    body.classList.add(scrollUp);
    body.classList.remove("top");
  }

  lastScroll = currentScroll;
});

window.addEventListener("load", () => {
  const currentScroll = window.scrollY;
  if (currentScroll <= 0) {
    body.classList.remove(scrollUp);
    body.classList.remove("top");
  }

  if (currentScroll === 0) {
    body.classList.add("top");
  }
});

/*  ==========================================================================
    Shuffle Filter - People
    ========================================================================== */

function filter_people(taxonomy_id) {
  var peopleGridElement = $(".peoplegrid .people");
  var peopleGridSizer = $(".peoplegrid .my-sizer-element");
  var Shuffle = window.Shuffle;

  // create shuffle instance
  if (!peopleShuffleGridInitialized) {
    peopleShuffleGrid = new Shuffle(peopleGridElement, {
      itemSelector: ".people_item",
      sizer: peopleGridSizer,
      buffer: 1
    });
    peopleShuffleGridInitialized = true;
  }

  // Filter people
  peopleShuffleGrid.filter(taxonomy_id);
}

if ($(".peoplegrid").length) {
  var Shuffle = window.Shuffle;

  var peopleShuffleGrid;
  var peopleShuffleGridInitialized = false;

  $(".peoplefilters__filter").click(function (event) {
    // Prevent default action - opening tag page
    if (event.preventDefault) {
      event.preventDefault();
    } else {
      event.returnValue = false;
    }

    if ($(this).hasClass("active")) {
      // reset on double click
      $(".peoplefilters__filter").removeClass("active");
      filter_people("");
      $(".peoplefilters__filter--all").addClass("active");
    } else {
      // add active class to category
      $(".peoplefilters__filter").removeClass("active");
      $(this).addClass("active");
      // filter people
      filter_people($(this).data("id"));
    }
  });
}

/*  ==========================================================================
			FILTERS - Company Portfolio Filtering
			========================================================================== */

const filters = document.querySelector(".filters"),
  filterSearch = document.querySelector(".filters__search"),
  filterSearchClear = document.querySelector(".filters__search__clear"),
  filterSearchInput = document.querySelector(".filters__search__input input");

const filterPageURL = filters ? filters.dataset.url : "";

let filtersInitialLoad = true;

// Get current from filters data

const filterGetFormData = function () {
  let filter_data = {};

  filter_settings.filters.forEach(function (el) {
    let checkedOptions = document.querySelectorAll('input[type="checkbox"][name=' + el.name + "]:checked");
    filter_data[el.name] = [...checkedOptions].map(x => x.value);
  });

  return filter_data;
};

const filterUpdateURL = function (filterData, searchData) {
  let url_params = "";
  for (const [key, value] of Object.entries(filterData)) {
    if (value.length > 0 && value !== "all") {
      if (url_params === "") {
        url_params = url_params + "?";
      } else {
        url_params = url_params + "&";
      }
      // Convert values to comma seperated string
      /* jshint ignore:start */

      let values = Object.keys(value)
        .map(function (k) {
          return value[k];
        })
        .join(",");
      /* jshint ignore:end */

      if (values !== "") {
        url_params = url_params + "filter_" + key + "=" + values;
      } else {
        url_params = "";
      }
    }
  }

  if (searchData) {
    if (url_params === "") {
      url_params = url_params + "?";
    } else {
      url_params = url_params + "&";
    }
    url_params = url_params + "search=" + searchData;
  }

  let currentPageUrl = window.location.href.split("?")[0];
  let newUrl = currentPageUrl + url_params;
  // history.pushState({ path: newUrl }, "", newUrl);

  if (url_params !== "") {
    history.pushState({}, "", newUrl);
  }

  if (history.pushState) {
    window.history.pushState({ path: newUrl }, "", newUrl);
  }
};

// Toggles All Content checkbox if there is selected filters within the group
const filterSelectedAllCheckboxes = function (groupName) {
  let noActiveFiltersInGroup = true;

  document.querySelectorAll('input[type="checkbox"][name=' + groupName + "]").forEach(el => {
    if (el.checked === true) {
      noActiveFiltersInGroup = false;
    }
  });
  const allGroupCheckbox = document.querySelector('input[type="checkbox"][name=all_' + groupName + "]");
  if (allGroupCheckbox) {
    allGroupCheckbox.checked = noActiveFiltersInGroup;
  }
};

// Setup up the active tags in the filter bar
const filterAddingActiveTags = function (filterData) {
  let hasClassActive = false;
  // Reset styles
  const fieldsets = document.querySelectorAll(".filters__fieldset");
  fieldsets.forEach(set => {
    set.classList.remove("filters__fieldset--active");
  });

  const fieldsetField = document.querySelectorAll(".filters__fieldset__field");
  fieldsetField.forEach(field => {
    field.classList.remove("filters__fieldset__field--active");
  });

  for (const [key, values] of Object.entries(filterData)) {
    if (values.length > 0) {
      // Make field group active
      document
        .querySelector(".filters__fieldset[data-value='" + key + "']")
        .classList.remove("filters__fieldset--active");

      for (const value of values) {
        // Make input field active

        let filter_input = document
          .querySelector("input[name='" + key + "'][value='" + value + "']")
          .closest(".filters__fieldset__field");

        filter_input.classList.add("filters__fieldset__field--active");

        const inputText = document.querySelector("input[name='" + key + "'][value='" + value + "']").nextElementSibling
          .innerHTML;
        if (inputText !== "All") {
          filter_input.parentElement.previousElementSibling.previousElementSibling.firstElementChild.innerHTML =
            inputText;
          filter_input.parentElement.previousElementSibling.previousElementSibling.classList.add("active");
          filter_input.parentElement.previousElementSibling.classList.add("hide");
        } else {
          filter_input.parentElement.previousElementSibling.previousElementSibling.classList.remove("active");
          filter_input.parentElement.previousElementSibling.classList.remove("hide");
        }

        const clearFilters = document.querySelectorAll(".clear-filter");

        clearFilters.forEach(clearFilter => {
          clearFilter.addEventListener("click", e => {
            const filter = e.target.closest(".filters__fieldset__filter");
            if (filter) {
              filter.classList.remove("active");
              filter.nextElementSibling.classList.remove("hide");
              filter.nextElementSibling.nextElementSibling.firstElementChild.firstElementChild.click();
            }
          });
        });

        hasClassActive = true;
      }
    }

    filterSelectedAllCheckboxes(key);
  }

  return hasClassActive;
};

const filterGetPosts = function (updateURL = false) {
  // Getting the forma data
  let filterData = filterGetFormData();
  let searchData = filterSearchInput.value;

  if (filterData || searchData) {
    // Update url
    if (updateURL) {
      filterUpdateURL(filterData, searchData);
    }

    let activeTagsNotEmpty = filterAddingActiveTags(filterData);

    if ((filtersInitialLoad && (activeTagsNotEmpty || searchData)) || !filtersInitialLoad) {
      filtersInitialLoad = false;

      // get site padder header height
      let siteheaderpadder = document.querySelector(".pageheader");
      let siteheaderpadderHeight = siteheaderpadder.offsetHeight;

      // get teams filter height
      let portFilter = document.querySelector(".filters");
      let portFilterHeight = portFilter.offsetHeight;

      let filterPin = document.querySelector(".filters-pin");

      const filterPinRec = filterPin.getBoundingClientRect();

      const top = 0;

      window.scrollTo({
        top: top,
        behavior: "smooth"
      });

      // If there's an active search, open the search field
      if (searchData) {
        document.querySelector(".filters__search").classList.add("filters__search--open");
        filterSearchClear.classList.add("active");
      }

      // Start filtering
      document.querySelector(".posts.loadmore-container").classList.add("filtering");
      document.querySelector(".filters").classList.add("filtering");

      let getPostsPage = php_variables.current_page;
      const currentPage = new URL(window.location);
      let currentPageNum = currentPage.searchParams.get("pagenum");

      //If there is more than one page to load
      if (currentPageNum && currentPageNum > 1) {
        currentPageNum = currentPageNum > php_variables.max_page ? php_variables.max_page : currentPageNum;

        getPostsPage = currentPageNum;
      }
      if (filterData["status"] && filterData["status"][0] === "all") {
        filterData["status"][0] = [];
      }
      if (filterData["location"] && filterData["location"][0] === "all") {
        filterData["location"][0] = [];
      }
      if (filterData["type"] && filterData["type"][0] === "all") {
        filterData["type"][0] = [];
      }
      if (filterData["area"] && filterData["area"][0] === "all") {
        filterData["area"][0] = [];
      }
      if (filterData["companycategories"] && filterData["companycategories"][0] === "all") {
        filterData["companycategories"][0] = [];
      }

      // Trigger ajax
      let data = {
        action: "filter",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function in enqueue-scripts.php
        page: php_variables.current_page,
        filter_settings: filter_settings, // passed in via wp_localize_script in filters.php
        filter_data: filterData,
        search_data: searchData,
        security: php_variables.nonce
      };

      $.ajax({
        url: php_variables.ajax_url,
        data: data, // form data
        dataType: "json", // this data type allows us to receive objects from the server
        type: "POST",
        success: function (data) {
          // when filter applied:
          // set the current page to 1
          php_variables.current_page = 1;

          // set the new query parameters
          php_variables.posts = data.posts;

          // set the new max page parameter
          php_variables.max_page = data.max_page;

          // hide load more button, if there are not enough posts for the second page

          const pagingLoadmore = document.querySelector(".paging__loadmore");
          if (pagingLoadmore) {
            if (data.max_page < 2) {
              pagingLoadmore.style.display = "none";
            } else {
              pagingLoadmore.style.display = "block";
            }
          }

          // insert the posts to the container
          const loadmoreContainer = document.querySelector(".posts.loadmore-container");
          if (loadmoreContainer) {
            loadmoreContainer.innerHTML = data.content;
            // Finish filtering
            loadmoreContainer.classList.remove("filtering");
            document.querySelector(".filters").classList.remove("filtering");

            const url = new URL(window.location.href);
            const viewParam = url.searchParams.get("view");

            // If view=true is in the URL, click the first .company element
            if (viewParam === "true") {
              const firstCompany = document.querySelector(".company__top");
              if (firstCompany) {
                // Create and dispatch a click event
                setTimeout(() => {
                  loadmoreContainer.scrollIntoView({ behavior: "smooth", block: "start" });
                  const event = new Event("click", { bubbles: true });
                  firstCompany.dispatchEvent(event);
                }, 1000);
              }
            }
          }

          setFilterTagsListeners();

          lazyLoadInstance.update();

          Waypoint.refreshAll();

          const connectButtons = document.querySelectorAll(".person__contact--connect");
          const connectForm = document.querySelector(".contact-form__connect");
          const connectOverlay = document.querySelector(".overlay");
          const connectCloseButton = document.querySelector(".contact-form__connect__close");

          const connectFormInit = function () {
            if (!connectCloseButton) {
              return;
            }

            connectButtons.forEach(function (connectButton) {
              connectButton.addEventListener("click", function (e) {
                e.preventDefault();
                connectForm.classList.toggle("active");
                overlay.classList.toggle("active");
                // Create a new URL object for the current location
                const url = new URL(window.location.href);

                const fieldName = document.querySelector(".advisor-field");
                const getName = this.getAttribute("data-name");
                fieldName.value = getName;

                // Trigger 'input' and 'change' events to notify Ninja Forms
                var inputEvent = new Event("input", { bubbles: true });
                var changeEvent = new Event("change", { bubbles: true });

                fieldName.dispatchEvent(inputEvent);
                fieldName.dispatchEvent(changeEvent);

                // Update the URL in the browser without reloading the page
                window.history.pushState({}, "", url);
              });
            });

            connectOverlay.addEventListener("click", function (e) {
              e.preventDefault();
              connectForm.classList.remove("active");
              connectOverlay.classList.remove("active");

              // Create a new URL object for the current location
              const url = new URL(window.location.href);

              // Remove the `popup` query parameter
              url.searchParams.delete("popup");

              // Update the URL in the browser without reloading the page
              window.history.pushState({}, "", url);
            });

            connectCloseButton.addEventListener("click", function (e) {
              e.preventDefault();
              connectForm.classList.remove("active");
              connectOverlay.classList.remove("active");

              // Create a new URL object for the current location
              const url = new URL(window.location.href);

              // Remove the `popup` query parameter
              url.searchParams.delete("popup");

              // Update the URL in the browser without reloading the page
              window.history.pushState({}, "", url);
            });

            // Check if the URL query string contains `popup=true`
          }; // contactFormInit();
          connectFormInit();

          const companyToggles = document.querySelectorAll(".company__top");
          const companyTiles = document.querySelectorAll(".tile--company");

          const companyAccordionInit = function () {
            if (!companyToggles) {
              return;
            }

            companyToggles.forEach(companyToggle => {
              companyToggle.addEventListener("click", function (evt) {
                if (!companyToggle.parentElement.parentElement.parentElement.classList.contains("active")) {
                  companyTiles.forEach(companyTile => {
                    companyTile.classList.remove("active");
                    companyTile.classList.remove("active__bottom");
                  });

                  companyToggle.parentElement.parentElement.parentElement.classList.toggle("active");
                  setTimeout(() => {
                    companyToggle.parentElement.parentElement.parentElement.classList.toggle("active__bottom");
                  }, 250);
                } else {
                  companyToggle.parentElement.parentElement.parentElement.classList.remove("active");
                  setTimeout(() => {
                    companyToggle.parentElement.parentElement.parentElement.classList.remove("active__bottom");
                  }, 250);
                }
              });
            });
          };
          companyAccordionInit();
        },
        error: function (data) {}
      });
    }
  }
};

const setFilterTagsListeners = function () {
  const allFilterTags = document.querySelectorAll(".filters__tag");
  allFilterTags.forEach(tag => {
    tag.addEventListener("click", function () {
      let filter_name = tag.dataset.name;
      let filter_value = tag.dataset.value;
      let filter_input = (document.querySelector(
        "input[name='" + filter_name + "'][value='" + filter_value + "']"
      ).checked = false);
      // Remove tag
      tag.remove();
      // Trigger filter
      filterGetPosts();
    });
  });
};

const filterSetupClearAll = function () {
  const filterClearAll = document.querySelectorAll(".filters__clearall");
  filterClearAll.forEach(btn => {
    btn.addEventListener("click", function () {
      // Clear search
      filterSearchInput.value = "";
      filterSearch.classList.remove("filters__search--open");
      filterSearchClear.classList.remove("active");

      // Uncheck all inputs
      const filterCheckboxes = document.querySelectorAll(".filters__fieldset__field input");
      filterCheckboxes.forEach(el => (el.checked = false));

      // Trigger filter
      filterGetPosts(true);

      filters.classList.remove("filters--searchopen");
      filters.classList.remove("filters--dropdownopen");
    });
  });
};

// Init Filter on posts pages
const filterInit = function () {
  let currentPageUrl = window.location.href.split("?")[0];

  const submitBtn = document.querySelector(".filters__apply");
  const filterForm = document.querySelector(".filters__form");
  const filterHeadings = document.querySelectorAll(
    ".filters__fieldset__heading:not(.filters__fieldset__heading--active)"
  );

  if (filterForm && filterForm.length) {
    // Get Posts based on Filter Form Data
    filterGetPosts(false);

    // Clear search on click
    filterSearchClear.addEventListener("click", function (e) {
      filterSearchInput.value = "";
      filterSearch.classList.remove("filters__search--open");
      filterSearchClear.classList.remove("active");
      filterGetPosts(true);
    });

    // Filter on submit
    filterForm.addEventListener("submit", function (e) {
      // Stop the form from submitting
      e.preventDefault();

      // Call the filtering post function
      filterGetPosts(true);
      filters.classList.remove("filters--searchopen");
      filters.classList.remove("filters--dropdownopen");
    });

    filterHeadings.forEach(filterHeading => {
      filterHeading.addEventListener("click", function (evt) {
        if (!filterHeading.classList.contains("filters__fieldset__heading--active")) {
          if (filterHeading.classList.contains("active")) {
            filterHeading.classList.remove("active");
          } else {
            // Otherwise, remove 'active' class from all items and add it to the clicked one
            filterHeadings.forEach(i => i.classList.remove("active"));
            filterHeading.classList.add("active");
          }
        }
      });
    });

    document.addEventListener("click", function (event) {
      const activeHeadings = document.querySelectorAll(".filters__fieldset__heading.active");

      if (activeHeadings.length > 0) {
        const isClickInsideHeading = event.target.closest(".filters__fieldset__heading");
        const isClickInsideFields = event.target.closest(".filters__fieldset__fields");

        if (!isClickInsideHeading && !isClickInsideFields) {
          activeHeadings.forEach(heading => heading.classList.remove("active"));
        }
      }
    });

    document.querySelectorAll(".filters__fieldset").forEach(fieldset => {
      fieldset.addEventListener("click", event => {
        if (event.target.closest(".filters__fieldset__field")) {
          const heading = fieldset.querySelector(".filters__fieldset__heading");
          if (heading.classList.contains("active")) {
            heading.classList.remove("active");
          }
        }
      });
    });

    const filterCheckboxes = filterForm.querySelectorAll(".filters__fieldset__field input");

    filterCheckboxes.forEach(checkbox => {
      checkbox.addEventListener("change", function (evt) {
        const parentFields = evt.target.parentElement.parentElement;
        const parentFieldsLoop = parentFields.querySelectorAll(".filters__fieldset__field");

        const getCurrentCheckbox = evt.target;
        const currentInput = getCurrentCheckbox;

        if (evt.target.value === "all") {
          parentFieldsLoop.forEach(loop => {
            loop.classList.remove("filters__fieldset__field--active");
            loop.querySelector("input").checked = false;
          });
          currentInput.parentElement.classList.add("filters__fieldset__field--active");
          currentInput.checked = true;
        } else {
          if (currentInput.parentElement.classList.contains("filters__fieldset__field--active")) {
            parentFieldsLoop[0].querySelector("input").checked = true;
          } else {
            parentFieldsLoop.forEach(loop => {
              loop.classList.remove("filters__fieldset__field--active");
              loop.querySelector("input").checked = false;
            });
            currentInput.parentElement.classList.add("filters__fieldset__field--active");
            currentInput.checked = true;

            const clearFilters = document.querySelectorAll(".clear-filter");

            clearFilters.forEach(clearFilter => {
              clearFilter.addEventListener("click", e => {
                const filter = e.target.closest(".filters__fieldset__filter");
                if (filter) {
                  filter.classList.remove("active");
                  filter.nextElementSibling.classList.remove("hide");
                  filter.nextElementSibling.nextElementSibling.firstElementChild.firstElementChild.click();
                }
              });
            });
          }
        }

        filterGetPosts(true);
        filters.classList.toggle("filters--dropdownopen");
      });
    });

    // Remove tags on click
    setFilterTagsListeners();

    // Clear all
    filterSetupClearAll();

    const connectButtons = document.querySelectorAll(".person__contact--connect");
    const connectForm = document.querySelector(".contact-form__connect");
    const connectOverlay = document.querySelector(".overlay");
    const connectCloseButton = document.querySelector(".contact-form__connect__close");

    const connectFormInit = function () {
      if (!connectCloseButton) {
        return;
      }

      connectButtons.forEach(function (connectButton) {
        connectButton.addEventListener("click", function (e) {
          e.preventDefault();
          connectForm.classList.toggle("active");
          overlay.classList.toggle("active");
          // Create a new URL object for the current location
          const url = new URL(window.location.href);

          const fieldName = document.querySelector(".advisor-field");
          const getName = this.getAttribute("data-name");
          fieldName.value = getName;

          // Trigger 'input' and 'change' events to notify Ninja Forms
          var inputEvent = new Event("input", { bubbles: true });
          var changeEvent = new Event("change", { bubbles: true });

          fieldName.dispatchEvent(inputEvent);
          fieldName.dispatchEvent(changeEvent);

          // Update the URL in the browser without reloading the page
          window.history.pushState({}, "", url);
        });
      });

      connectOverlay.addEventListener("click", function (e) {
        e.preventDefault();
        connectForm.classList.remove("active");
        connectOverlay.classList.remove("active");

        // Create a new URL object for the current location
        const url = new URL(window.location.href);

        // Remove the `popup` query parameter
        url.searchParams.delete("popup");

        // Update the URL in the browser without reloading the page
        window.history.pushState({}, "", url);
      });

      connectCloseButton.addEventListener("click", function (e) {
        e.preventDefault();
        connectForm.classList.remove("active");
        connectOverlay.classList.remove("active");

        // Create a new URL object for the current location
        const url = new URL(window.location.href);

        // Remove the `popup` query parameter
        url.searchParams.delete("popup");

        // Update the URL in the browser without reloading the page
        window.history.pushState({}, "", url);
      });

      // Check if the URL query string contains `popup=true`
    }; // contactFormInit();
    connectFormInit();

    const companyToggles = document.querySelectorAll(".company__top");
    const companyTiles = document.querySelectorAll(".tile--company");

    const companyAccordionInit = function () {
      if (!companyToggles) {
        return;
      }

      companyToggles.forEach(companyToggle => {
        companyToggle.addEventListener("click", function (evt) {
          if (!companyToggle.parentElement.parentElement.parentElement.classList.contains("active")) {
            companyTiles.forEach(companyTile => {
              companyTile.classList.remove("active");
              companyTile.classList.remove("active__bottom");
            });

            companyToggle.parentElement.parentElement.parentElement.classList.toggle("active");
            setTimeout(() => {
              companyToggle.parentElement.parentElement.parentElement.classList.toggle("active__bottom");
            }, 250);
          } else {
            companyToggle.parentElement.parentElement.parentElement.classList.remove("active");
            setTimeout(() => {
              companyToggle.parentElement.parentElement.parentElement.classList.remove("active__bottom");
            }, 250);
          }
        });
      });

      var mainBtn = document.querySelector(".main--companies .paging__loadmore");

      var observer = new IntersectionObserver(
        function (entries, observer) {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.click();
            }
          });
        },
        { threshold: 1.0 }
      );

      if (mainBtn) {
        observer.observe(mainBtn);
      } else {
        console.log("Button not found.");
      }
    };
    companyAccordionInit();
  }
};

filterInit();
